import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Decorative, Core } from "@faire/design-tokens";
import { Button } from "@faire/web--source/slate/Button";
import { Column, Flex } from "@faire/web--source/slate/Layout";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import React from "react";
import styled from "styled-components";
import { StyledIconByName } from "@faire/retailer/views/product/utils/StyledIconByName";
export var IconTextTile = function(param) {
    var iconTextLayoutElementData = param.iconTextLayoutElementData, onCTAClick = param.onCTAClick;
    return /*#__PURE__*/ _jsxs(TileWrapper, {
        $backgroundColor: iconTextLayoutElementData.background_color,
        children: [
            iconTextLayoutElementData.icon && /*#__PURE__*/ _jsx(IconWrapper, {
                $backgroundColor: iconTextLayoutElementData.icon.background_color,
                children: /*#__PURE__*/ _jsx(StyledIconByName, {
                    name: iconTextLayoutElementData.icon.type,
                    fontSize: iconTextLayoutElementData.icon.size + "px",
                    color: iconTextLayoutElementData.icon.color
                })
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: 12
            }),
            /*#__PURE__*/ _jsx(Typography, {
                variant: "subheadingSansMedium",
                children: iconTextLayoutElementData.main_text
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: "1x"
            }),
            /*#__PURE__*/ _jsx(Typography, {
                variant: "paragraphSansRegular",
                children: iconTextLayoutElementData.description_text
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: "2x"
            }),
            /*#__PURE__*/ _jsx(Button, {
                variant: "tertiary",
                linkTo: iconTextLayoutElementData.cta_link,
                style: {
                    minWidth: "76px",
                    whiteSpace: "nowrap",
                    justifyContent: "flex-start"
                },
                onClick: onCTAClick,
                children: /*#__PURE__*/ _jsx(Typography, {
                    color: Core.text.enabled,
                    children: iconTextLayoutElementData.cta_text
                })
            })
        ]
    });
};
var TileWrapper = styled(Column).attrs({
    justify: "flex-end"
}).withConfig({
    componentId: "sc-53c77325-0"
})([
    "position:relative;width:100%;height:100%;padding:",
    ";background-color:",
    ";"
], getSpacing("2x"), function(param) {
    var $backgroundColor = param.$backgroundColor;
    return $backgroundColor ? $backgroundColor : Decorative.tint.orange;
});
var IconWrapper = styled(Flex).attrs({
    align: "center",
    justify: "center"
}).withConfig({
    componentId: "sc-53c77325-1"
})([
    "width:",
    ";height:",
    ";border-radius:100%;background-color:",
    ";"
], getSpacing("5x"), getSpacing("5x"), function(param) {
    var $backgroundColor = param.$backgroundColor;
    return $backgroundColor ? $backgroundColor : Decorative.tint.neutral;
});
